const pendingRequests = new Map();

export function deduplicatedFetch(url, options) {
  if (pendingRequests.has(url)) {
    return pendingRequests.get(url).then((response) => response.clone());
  }

  const request = fetch(url, options).finally(() => {
    pendingRequests.delete(url);
  });
  pendingRequests.set(url, request);

  return request.then((response) => response.clone());
}
